import React from 'react';
import CardCommon from '@op/components/CardCommon';
import { StatusTip } from 'tea-component';
import XVideoCard from '@opm/pages/Videos/components/XVideoCard';
import { LanguageType } from '@op/types/common';
import { DEFAULT_METRICS } from '@opm/pages/Videos/constants';

interface IListViewProps {
  language: any;
  changePageInfo: (value: any) => void;
  cardRecords?: Array<any>;
  loading?: boolean;
  total?: number;
  data?: Array<any>;
}

export default function ListView({
  language,
  cardRecords = [],
  loading,
}: IListViewProps) {
  return (
    <CardCommon
      contentCard
      loading={loading && cardRecords.length === 0}
      loadingHeight={350}
      empty={cardRecords.length === 0}
      emptyHeight={350}
    >
      <>
        <div className="dbom-x-video-list">
          {cardRecords.map((item: any, index: number) => (
            <XVideoCard
              key={index}
              item={item}
              metricsConfig={DEFAULT_METRICS.filter(item => item.key !== "retweet_count")}
              language={language as LanguageType}
            />
          ))}
        </div>
        {loading && cardRecords.length !== 0 && (
          <div className="loading-common dbom-loading-common">
            <StatusTip status="loading" />
          </div>
        )}
      </>
    </CardCommon>
  );
}
